export default __webpack_public_path__ + "static/media/play-circle.fd27dd07.svg";